import React from 'react';
import cx from 'classnames';

export interface NavigationItemProps {
  className?: string;
  label: string;
  iconClassName: string;
  onSelected: (label: string) => void;
  selected?: boolean;
}

export default function NavigationItem({
  label,
  className,
  iconClassName,
  selected,
  onSelected,
}: NavigationItemProps) {
  const selectedColorBackground = 'v2-bg-neutral-600';

  return (
    <div
      onClick={() => onSelected(label)}
      className={cx(
        className,
        'w-20 flex flex-col gap-y-1 text-center items-center px-4 py-2.5 cursor-pointer',
        {
          [selectedColorBackground]: selected,
        }
      )}
    >
      <i className={cx(iconClassName, 'icon')} />
      <span>{label}</span>
    </div>
  );
}
